import DOMPurify from "dompurify";
import axios from "../../api/axios";

export const getActiveBroadcasts = async (token, signal) => {
  if (!token) return [];
  const response = await axios.get("/Order/activeBroadCast", {
    headers: { Authorization: `Bearer ${token}` },
    timeout: 15000,
    signal,
  });
  if (!response || !Number.isInteger(response.status) || response.status < 200 || response.status >= 300) {
    throw new Error("Unable to load active broadcasts");
  }
  if (response.status === 204 || response.data == null || response.data === "") return [];

  const records = Array.isArray(response.data) ? response.data : [response.data];
  if (!records.every((record) => record && Number.isInteger(record.id) && record.id >= 0 &&
    (record.status === 0 || record.status === 1) &&
    (record.name == null || typeof record.name === "string") &&
    (record.content == null || typeof record.content === "string"))) {
    throw new Error("Unexpected active broadcast response");
  }
  return records.filter((record) => record.status === 0)
    .sort((first, second) => (Date.parse(second.createdOn) || 0) - (Date.parse(first.createdOn) || 0) || second.id - first.id)
    .slice(0, 1).map((record) => ({
    id: String(record.id),
    title: record.name || "Announcement",
    message: DOMPurify.sanitize(record.content || ""),
    version: JSON.stringify([record.id, record.updatedOn, record.name, record.content]),
    createdOn: record.createdOn,
  }));
};
